/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EMR } from './EMR';
import type { Location } from './Location';

export type Clinics = {
    readonly id?: number;
    name: string;
    /**
     * Contact email for the clinic. Will display in the Viewer.
     */
    email?: string | null;
    /**
     * Contact phone number for the clinic. Will display in the Viewer.
     */
    phone?: string | null;
    readonly location?: Location;
    readonly emrs?: Array<EMR>;
    /**
     * Sonic ConnectDx identifier for clinics. Ids are issued and maintained by the Corepoint/ConnectDx Sonic teams.
     */
    connectdx_practice_id?: number | null;
    /**
     * ModMed's clinic_id value to map from incoming WPL order messages. Maps to MSH.5
     */
    modmed_clinic_id?: string | null;
    /**
     * Nextech's clinic_id value to map from incoming order messages. Maps to MSH.3
     */
    nextech_clinic_id?: number | null;
    /**
     * eClinicalWorks's clinic_id value to map from incoming order messages. Maps to MSH.3
     */
    ecw_clinic_id?: number | null;
    /**
     * EZDerm's client_id to route results in their system to this particular customer
     */
    ezderm_client_id?: number | null;
    /**
     * True to send case results to EZDerm
     */
    ezderm_enabled?: boolean;
    customer_type?: Clinics.customer_type | null;
    /**
     * Third-party clinic ID, e.g. Sonic g_number
     */
    external_clinic_id?: number | null;
    /**
     * Enable white glove service (aka priority) for this clinic
     */
    tat_priority?: boolean;
    /**
     * Whether or not to use the supervising physician for this clinic. If true, the supervising physician will be displayed on the accessioning page.
     */
    use_supervising_physician?: boolean;
    is_archived?: boolean;
}

export namespace Clinics {

    export enum customer_type {
        VALUEWATCH = 'VALUEWATCH',
        BUSINESSWATCH = 'BUSINESSWATCH',
        TC_ONLY = 'TC_ONLY',
        NON_DIAGNOSTIC = 'NON_DIAGNOSTIC',
        VW_BW = 'VW_BW',
    }


}
